module.exports = __webpack_public_path__ + "img/logo_philco.e873c1b6.svg";